import { activeAssistantMessageIds } from './active-assistant-message-id';

export interface StoreAbortController {
	abort: () => Promise<void>;
}

export interface StoreAbortControllerSettings {
	storeAbortController: StoreAbortController;
	confirmAbort: () => void;
	abortController: AbortController;
}

export const createStoreAbortController = (
	getAssistantMessageId?: () => string | undefined,
): StoreAbortControllerSettings => {
	const abortController = new AbortController();
	let resolveAbort: () => void;

	const confirmAbort = () => {
		resolveAbort();
	};

	const abort = () => {
		abortController.abort();
		return new Promise<void>((resolve) => {
			resolveAbort = resolve;
		});
	};

	const storeAbortController = { abort };
	if (getAssistantMessageId) {
		activeAssistantMessageIds.register(storeAbortController, getAssistantMessageId);
	}

	return {
		abortController,
		storeAbortController,
		confirmAbort,
	};
};
